// @flow
import { useCallback, useState, useRef } from 'react';

import FilterSection from '../catalogFilters/FilterSection';
import FilterTab from '../catalogFilters/FilterTab';
import FilterCheckItem from '../catalogFilters/FilterCheckItem';
import FilterItems from '../catalogFilters/FilterCheckItems';

import QuestionMarkPopup from '@components/popups/QuestionMark';
import * as ModernContent from '@components/popups/content/Modern';
import * as ClassicContent from '@components/popups/content/Classic';
import * as VintageContent from '@components/popups/content/Vintage';
import * as InfinityContent from '@components/popups/content/Infinity';
import * as EngravedContent from '@components/popups/content/Engraved';
import * as StackableContent from '@components/popups/content/Stackable';

import css from '@styles/bandFilters';

type TProps = {
  isOpen: boolean,
  onToggle: () => void,
  onFilterCheckToggle: (Category: string, Value: string) => void,
  selectedItems: Array<string>
};

function itemIsSelected(selectedItems, item) {
  return selectedItems.indexOf(item) >= 0;
}

export default function DesignFilters({
  onFilterCheckToggle,
  selectedItems,
  isOpen,
  onToggle
}: TProps) {
  const handleCheckToggle = useCallback(e => {
    onFilterCheckToggle('design', e.currentTarget.value);
  }, []);

  return (
    <FilterSection
      className={css.design}
      enableClickOutside={isOpen}
      onClickOutside={onToggle}
    >
      <FilterTab
        name='Design'
        className={css.designTab}
        showingContent={isOpen}
        activeFilterCount={selectedItems.length}
        onClick={onToggle}
        key='design-tab'
      />
      <FilterItems
        className={css.designContent}
        show={isOpen}
        key='design-content'
      >
        <FilterCheckItem
          label='Modern'
          inputValue='Modern'
          htmlId='design-modern'
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={ModernContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Modern')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label='Classic'
          inputValue='Classic'
          htmlId='design-classic'
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={ClassicContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Classic')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label='Vintage'
          inputValue='Vintage'
          htmlId='design-vintage'
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={VintageContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Vintage')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label='Infinity'
          inputValue='Infinity'
          htmlId='design-infinity'
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={InfinityContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Infinity')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label='Engraved'
          inputValue='Engraved'
          htmlId='design-engraved'
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={EngravedContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Engraved')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label='Stackable'
          inputValue='Stackable'
          htmlId='design-stackable'
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={StackableContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Stackable')}
          onChange={handleCheckToggle}
        />
      </FilterItems>
    </FilterSection>
  );
}
